<template>
  <message-template :direction="direction" :time="time" :channel="channel">
    <div class="log-image-block">
      <img v-if="hasImg" class="image" :src="imgSrc" :alt="imgAlt" />
      <img v-else src="@/assets/images/placeholder-square.jpg" alt="placeholder" />
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from './MessageTemplate.vue';

export default {
  name: 'buttonTemplate',
  components: {
    'message-template': MessageTemplate,
  },
  props: {
    data: {
      type: Object,
    },
    direction: {
      type: String,
      default: '',
    },
    imgUrlField: {
      type: String,
      default: 'url',
    },
    imgAltField: {
      type: String,
      default: 'alt',
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
    },
  },
  computed: {
    hasImg() {
      if (this.data && this.data[this.imgUrlField]) {
        return true;
      }
      if (this.data && this.data.answers && this.data.answers[0] && this.data.answers[0].imageUrl) {
        return true;
      }
      return false;
    },
    imgSrc() {
      if (this.data && this.data[this.imgUrlField]) {
        return this.data[this.imgUrlField];
      } if (this.data
        && this.data.answers
        && this.data.answers[0]
        && this.data.answers[0][this.imgUrlField]) {
        return this.data.answers[0][this.imgUrlField];
      }
      return '';
    },
    imgAlt() {
      if (this.data && this.data[this.imgAltField]) {
        return this.data[this.imgAltField];
      }
      return 'Image';
    },
  },
};
</script>
<style lang="scss" scoped>
.log-image-block {
  max-width: 300px;
  overflow: hidden;
  background-color: #efefef;
  border-radius: 10px 10px 10px 10px;
  .image {
    width: 100%;
    height: auto;
  }
}
</style>
